import React from 'react';
import { Form } from 'antd';
import '../TextInput/TextInput.less';
import { FormInstance } from 'antd/lib/form';

export type FormProps = {
  className?: string;
  form?: FormInstance;
  onSuccess?: (values: { [key: string]: any }) => void;
  onError?: ({
    values,
    errorFields,
    outOfDate,
  }: {
    values?: any;
    errorFields?: any;
    outOfDate?: any;
  }) => void;
};

const TForm: React.FC<FormProps> = ({ onSuccess, onError, ...props }) => {
  return (
    <Form onFinish={onSuccess} onFinishFailed={onError} {...props}>
      {props.children}
    </Form>
  );
};

export default TForm;
